import { api, ApiResponse } from "../lib/api.ts";
import { QuestionData, CreateQuestionRequest, AwardData, CreateAwardData, SeasonWinnerData, CreateSeasonWinnerData } from "../entry/server/game.ts";

export const gameService = {
    getQuestions: async (page: number, search?: string): Promise<ApiResponse<QuestionData[]>> => {
        return await api.get<QuestionData[]>({ url: "questions", queryParams: { "page": page.toString(), "search": search ?? "" } });
    },
    getQuestion: async (id: number): Promise<ApiResponse<QuestionData>> => {
        return await api.get<QuestionData>({ url: `questions/${id}` });
    },
    createQuestion: async (question: CreateQuestionRequest): Promise<ApiResponse<QuestionData>> => {
        return await api.post<QuestionData>({ url: "questions", body: question as unknown as Record<string, unknown> });
    },
    updateQuestion: async (id: number, question: CreateQuestionRequest): Promise<ApiResponse<QuestionData>> => {
        return await api.put<QuestionData>({ url: `questions/${id}`, body: question as unknown as Record<string, unknown> });
    },
    deleteQuestion: async (id: number): Promise<ApiResponse<QuestionData>> => {
        return await api.delete<QuestionData>({ url: `questions/${id}` });
    },
    getAwards: async (page: number): Promise<ApiResponse<AwardData[]>> => {
        return await api.get<AwardData[]>({ url: "awards", queryParams: { "page": page.toString() } });
    },
    getAward: async (id: number): Promise<ApiResponse<AwardData>> => {
        return await api.get<AwardData>({ url: `awards/${id}` });
    },
    createAward: async (award: CreateAwardData): Promise<ApiResponse<AwardData>> => {
        return await api.post<AwardData>({ url: "awards", body: award as unknown as Record<string, unknown> });
    },
    updateAward: async (id: number, award: CreateAwardData): Promise<ApiResponse<void>> => {
        return await api.put<void>({ url: `awards/${id}`, body: award as unknown as Record<string, unknown> });
    },
    deleteAward: async (id: number): Promise<ApiResponse<void>> => {
        return await api.delete<void>({ url: `awards/${id}` });
    },
    getSeasonWinners: async (page: number, season?: number): Promise<ApiResponse<SeasonWinnerData[]>> => {
        const queryParams: Record<string, string> = { page: page.toString() };
        if (season && season > 0) {
            queryParams.season = season.toString();
        }
        return await api.get<SeasonWinnerData[]>({ url: "season-winners", queryParams });
    },
    getSeasonWinner: async (id: number): Promise<ApiResponse<SeasonWinnerData>> => {
        return await api.get<SeasonWinnerData>({ url: `season-winners/${id}` });
    },
    createSeasonWinner: async (winner: CreateSeasonWinnerData): Promise<ApiResponse<void>> => {
        return await api.post<void>({ url: "season-winners", body: winner as unknown as Record<string, unknown> });
    },
    updateSeasonWinner: async (id: number, winner: CreateSeasonWinnerData): Promise<ApiResponse<void>> => {
        return await api.put<void>({ url: `season-winners/${id}`, body: winner as unknown as Record<string, unknown> });
    },
    deleteSeasonWinner: async (id: number): Promise<ApiResponse<void>> => {
        return await api.delete<void>({ url: `season-winners/${id}` });
    },
}